import { render, staticRenderFns } from "./EModalExportarAulaInfantil.vue?vue&type=template&id=48f8cb85"
import script from "./EModalExportarAulaInfantil.vue?vue&type=script&lang=js"
export * from "./EModalExportarAulaInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports